import { Stack, Typography } from "@mui/joy";
import { ICellRendererParams } from "ag-grid-community";

function YesNoCellRenderer({ value }: ICellRendererParams<any>) {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography component={"span"} noWrap>
        {value ? "Yes" : "No"}
      </Typography>
    </Stack>
  );
}

export default YesNoCellRenderer;
